var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReportDetailSearch = function SvgReportDetailSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E44134",
    fillRule: "nonzero",
    d: "M14.192 13.024c1.897-2.335 1.459-5.691-.876-7.588s-5.691-1.46-7.588.875c-1.897 2.19-1.605 5.546.73 7.443 1.897 1.46 4.377 1.605 6.42.292l1.168 1.167-.146.146q-.438.438 0 .876l1.897 1.897c-3.94 2.773-9.34 2.48-12.842-1.022a9.953 9.953 0 0 1 0-14.155 9.953 9.953 0 0 1 14.155 0c3.503 3.502 3.795 8.902 1.022 12.842L16.235 13.9q-.438-.438-.876 0l-.146.146zm-4.232.292c-2.043 0-3.794-1.605-3.794-3.794 0-2.043 1.605-3.794 3.794-3.794 2.043 0 3.794 1.605 3.794 3.794-.146 2.043-1.751 3.794-3.794 3.794"
  })));
};
export default SvgReportDetailSearch;